"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workspaceStoreAppPayments = void 0;
exports.workspaceStoreAppPayments = function (axios) {
    return {
        getStorePaymentsPaymentNo: function (request) {
            var paymentNo = request.pathParams.paymentNo;
            return axios.get("/store/payments/" + paymentNo);
        }
    };
};
